import React, { ReactNode } from 'react';
import styles from './Text.module.scss';
import cn from 'classnames';

export interface TextProps {
  children?: ReactNode;
  className?: string;
  centered?: boolean;
  blue?: boolean;
  bold?: boolean;
  h1?: boolean;
}
function Text(props: TextProps) {
  const { children, className, centered, blue, bold, h1 } = props;

  let textClassName = cn(className, styles.text);
  if (centered) {
    textClassName = cn(textClassName, styles.centered);
  }
  if (blue) {
    textClassName = cn(textClassName, styles.blue);
  }
  if (bold) {
    textClassName = cn(textClassName, styles.bold);
  }

  if (h1) {
    return <h1 className={textClassName}>{children}</h1>;
  }

  return <span className={textClassName}>{children}</span>;
}

export default Text;
